export default {
    "entityName": "protocol_has_site",
    "title": "Protocol site",
    id: ['protocol_id', 'site_id'],
    "pagination": {
        "rowsPerPage": 10,
        "page": 1,
        "sortBy": "protocol.name",
        "descending": false
    },
    "fields": [
        {
            value: "_provider",
            visible: false,
            deps: ['protocol_id'],
            default: (item, args, selected) => selected && selected.provider
        },
        {
            full:true,
            "value": "protocol_id",
            "text": "Protocol",
            title: "name",
            subtitle: item => `${item.provider}`,
            "type": "autocomplete",
            filter: (item, search) => [{ 'protocol.name': `%${search}%`}],
            "table": {
                "sortable": true,
                filter: true
            },
            render: item => `${item.protocol.name}`,
            validators: ['required'],
            readonly: item => (item.protocol_id ?? '')  !== '' //ISSUE 187
        },
        {
            full:true,
            "value": "site_id",
            "text": "Site",
            title: "factor_label",
            subtitle: item => `${item.city} - ${item.country_code}`,
            "type": "autocomplete",
            // filter: (item, search) => [{ 'site.name': `%${search}%`}, {'site.city': `%${search}%`}, {'site.code': `%${search}%`}],
            filter: (item, search) => [{ 'site.factor_label': `%${search}%`}],
            "table": {
                "sortable": true,
                filter: true
            },
            render: item => `${item.site.factor_label}`,
            validators: ['required'],
            readonly: item => (item.site_id ?? '')  !== '' //ISSUE 187
        },
        {
            value:'code',
            text:'Code',
            readonly: false, //issue 218 - commentato item => item._provider == 'REDCap' || !item.site_id || (item.protocol && item.protocol.provider == 'REDCap'),
            default: (item, args, selected) => selected && selected.code,
            deps:['_provider', 'site_id'],
            "table": {
                "sortable": true,
                filter: true
            },
            "validators": [
                "required",
            ]
        },

        {
            "value": "factor_level",
            "text": "Factor level",
            "type": "text",
        },
        //issue 169
        {
            value: 'pi_qualification',
            text:'PI Qualification',
            'type': 'list',
            'list': [
                'Dr.',
                'Prof.'
            ]
            /*,
            'validators': [
                'required'
            ]*/
        },
        //issue 169
        {
            value:'pi_first_name',
            text:'PI First name',
            "table": {
                "text" : "PI",
                "sortable": true,
                filter: true
            },
            /*
            "validators": [
                "required",
            ],*/
            render: (item) => {
                return (item.pi_first_name ? item.pi_first_name : '') + ' ' + (item.pi_last_name ? item.pi_last_name : '')
            },
            filter: (item, search) => {
                return [{pi_first_name: `%${search}%`}, {pi_last_name: `%${search}%`}]
            }

        },

        {
            value:'pi_last_name',
            text:'PI Last name'
            /*,
            "validators": [
                "required",
            ]*/
        },

        {
            value:'pi_email',
            text:'PI EMail',
            "validators": [
            ]
        },

        {
            value:'pi_phone',
            text:'PI Phone',
            "validators": [
            ]
        },

       

    ],
    "actions": [
        "upsert",
        "remove",
        "audit_trail"
    ]
}